import React, { useState, useEffect } from "react";
import { useChat } from "../../contexts/ChatContext";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import { useMediaQuery } from "react-responsive";
import { Button, Drawer } from "antd";
import { MessageOutlined, CloseOutlined } from "@ant-design/icons";

const ChatContainer = ({ quoteId, onClose, className = "" }) => {
  const { startConversation, currentConversation, setCurrentConversation } = useChat();
  const [mobileView, setMobileView] = useState("list"); // 'list' or 'conversation'
  const [drawerVisible, setDrawerVisible] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Initialisation si quoteId fourni
  useEffect(() => {
    const initChat = async () => {
      if (quoteId) {
        try {
          await startConversation(quoteId);
          if (isMobile) {
            setMobileView("conversation");
          }
        } catch (error) {
          console.error("Erreur lors de l'init du chat:", error);
        }
      }
    };

    initChat();
  }, [quoteId, isMobile, startConversation]);

  const handleSelectConversation = (conversation) => {
    setCurrentConversation(conversation);
    if (isMobile) setMobileView("conversation");
  };

  const handleBackToList = () => {
    if (isMobile) setMobileView("list");
  };

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  /* === Desktop layout === */
  if (!isMobile) {
    return (
      <div
        className={`flex h-[600px] bg-[#1a1a1d] text-gray-200 rounded-xl shadow-2xl overflow-hidden border border-gray-700 ${className}`}
      >
        {/* Liste des conversations */}
        <div className="w-1/3 border-r border-gray-700 bg-[#111]">
          <ChatList onSelectConversation={handleSelectConversation} />
        </div>

        {/* Fenêtre de chat */}
        <div className="flex-1 flex flex-col bg-[#1a1a1d]">
          <ChatWindow
            conversation={currentConversation}
            onBack={handleBackToList}
            className="flex-1"
          />
        </div>
      </div>
    );
  }

  /* === Mobile layout === */
  return (
    <>
      {/* Bouton flottant d’ouverture */}
      <Button
        shape="circle"
        size="large"
        icon={<MessageOutlined />}
        onClick={toggleDrawer}
        className="fixed bottom-6 right-6 z-50 shadow-lg"
        style={{
          backgroundColor: "#d4af37",
          border: "none",
          color: "#111",
          fontWeight: "bold",
        }}
      />

      <Drawer
        title={
          <div className="flex items-center justify-between text-gray-200">
            <span className="font-semibold text-gold-500">💬 Messages</span>
            <Button
              type="text"
              icon={<CloseOutlined style={{ color: "#d4af37" }} />}
              onClick={toggleDrawer}
              size="small"
            />
          </div>
        }
        placement="right"
        closable={false}
        onClose={toggleDrawer}
        open={drawerVisible}
        width="100%"
        bodyStyle={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          height: "calc(100% - 55px)",
          backgroundColor: "#1a1a1d",
        }}
        className="chat-drawer"
      >
        {mobileView === "list" ? (
          <ChatList
            onSelectConversation={(conv) => {
              handleSelectConversation(conv);
              setMobileView("conversation");
            }}
          />
        ) : (
          <ChatWindow
            conversation={currentConversation}
            onBack={handleBackToList}
            className="flex-1"
          />
        )}
      </Drawer>
    </>
  );
};

export default ChatContainer;
